const API =
  process.env.REACT_APP_TIMESHEET_API;

export const PAGE_SIZE = 25;

const qs = params =>
  Object.keys(params || {})
    .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');

export const fetchTimesheetEntriesPage = async params => {
  const res = await fetch(
    `${API}/entries?${qs({
      limit: PAGE_SIZE,
      ...params,
    })}`,
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data.error || data.message || `Failed to load entries (${res.status})`,
    );
  }

  // Support both paginated `{ entries, total, summary }` and legacy `{ entries }`.
  const entries = Array.isArray(data)
    ? data
    : Array.isArray(data.entries)
      ? data.entries
      : [];
  const total =
    typeof data.total === 'number' ? data.total : entries.length;
  const hasMore =
    typeof data.hasMore === 'boolean'
      ? data.hasMore
      : typeof data.total === 'number'
        ? (params.offset || 0) + entries.length < data.total
        : false;

  return {
    entries,
    total,
    hasMore,
    limit: typeof data.limit === 'number' ? data.limit : PAGE_SIZE,
    offset: typeof data.offset === 'number' ? data.offset : params.offset || 0,
    summary: data.summary || null,
  };
};

/** Convenience wrapper — returns entries array only */
export const fetchTimesheetEntries = async params => {
  const page = await fetchTimesheetEntriesPage({
    ...params,
    limit: params.limit || 100,
    offset: params.offset || 0,
  });
  return page.entries;
};

export const fetchTimesheetEntry = async (id, appname) => {
  const res = await fetch(
    `${API}/entries/${id}?appname=${encodeURIComponent(appname)}`,
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || 'Failed to load entry');
  }
  return data.entry;
};

export const decideTimesheetEntry = async (id, body) => {
  const res = await fetch(`${API}/entries/${id}/decide`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.error || 'Decision failed');
    err.errors = data.errors;
    throw err;
  }
  return data.entry;
};

export const fetchTimesheetExport = async params => {
  const res = await fetch(`${API}/export?${qs(params)}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Export failed');
  return data;
};

/** YYYY-MM-DD for local calendar day `daysAgo` days before today (0 = today). */
export const localDateDaysAgo = (daysAgo = 0) => {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - daysAgo);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Preview cap for department tab rows (newest first, per department). */
export const DEPARTMENT_PREVIEW_ROWS = 30;

/** Default Export From/To span (days). Backend still returns all when dates omitted. */
export const EXPORT_DEFAULT_RANGE_DAYS = 35;
